import { ReactNode, useEffect, useState } from 'react';

interface PopupContainerProps {
  children: ReactNode;
  className?: string;
}

const PopupContainer = ({ children, className = '' }: PopupContainerProps) => {
  const [isHeightLessThan864, setIsHeightLessThan864] = useState<boolean>(false);

  useEffect(() => {
    const handleResize = () => {
      setIsHeightLessThan864(window.innerHeight < 864);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const headerHeight = document.querySelector("header")?.clientHeight || 0;
    document.documentElement.style.setProperty(
      "--header-height",
      `${headerHeight}px`
    );
  }, []);

  return (
    <div
      className={`
        max-w-[552px] mx-auto flex justify-center
        ${isHeightLessThan864
          ? 'h-auto px-4 py-8'
          : 'h-[calc(100vh-var(--header-height,80px))] py-0'
        }
        ${className}
      `}
      tabIndex={0}
    >
      <div
        className={`
          max-w-[800px] p-6 sm:p-8 rounded-2xl
          bg-white dark:bg-primary-20
          shadow-[0_4px_24px_rgba(0,0,0,0.08)] dark:shadow-[0_4px_24px_rgba(0,0,0,0.3)]
          flex flex-col items-center text-center
          h-fit w-full relative
          ${isHeightLessThan864 ? 'top-0' : 'top-[15%]'}
        `}
      >
        {children}
      </div>
    </div>
  );
};

export default PopupContainer;
